import React, { createContext, useContext, useState } from 'react';

const TabsContext = createContext();

export const Tabs = ({ defaultValue, children }) => {
  const [active, setActive] = useState(defaultValue);

  return (
    <TabsContext.Provider value={{ active, setActive }}>
      <div>{children}</div>
    </TabsContext.Provider>
  );
};

export const TabsList = ({ children }) => (
  <div className="flex space-x-2 border-b mb-4">{children}</div>
);

export const TabsTrigger = ({ value, children }) => {
  const { active, setActive } = useContext(TabsContext);

  return (
    <button
      onClick={() => setActive(value)}
      className={`px-4 py-2 font-semibold transition duration-200 ${
        active === value
          ? 'border-b-2 border-blue-600 text-blue-600'
          : 'text-gray-500 hover:text-blue-500'
      }`}
    >
      {children}
    </button>
  );
};

export const TabsContent = ({ value, children }) => {
  const { active } = useContext(TabsContext);
  return active === value ? <div className="mt-4">{children}</div> : null;
};
